import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export const createClassName = (classes: Array<string | false | undefined>) =>
  classes.filter((cla) => Boolean(cla)).join(' ')

// Merge tailwind classes and custom classes
export const mtc = (styles: ClassValue, ...classNames: ClassValue[]) =>
  twMerge(clsx(styles, ...classNames))

export const supportColorUtilityClassList = [
  /* NEUTRAL */
  'neutral-0',
  'neutral-25',
  'neutral-50',
  'neutral-100',
  'neutral-200',
  'neutral-300',
  'neutral-400',
  'neutral-500',
  'neutral-600',
  'neutral-700',
  'neutral-800',
  'neutral-900',

  /* ORANGE (PRIORITY) */
  'orange-0',
  'orange-25',
  'orange-50',
  'orange-100',
  'orange-200',
  'orange-300',

  /* GREEN (PRIMARY) */
  'green-0',
  'green-25',
  'green-50',
  'green-100',
  'green-200',
  'green-300',

  /* MOSS (SECONDARY) */
  'moss-0',
  'moss-25',
  'moss-50',
  'moss-100',
  'moss-200',
  'moss-300',

  /* RED (SECONDARY) */
  'red-0',
  'red-25',
  'red-50',
  'red-100',
  'red-200',
  'red-300',

  /* YELLOW (SECONDARY) */
  'yellow-0',
  'yellow-25',
  'yellow-50',
  'yellow-100',
  'yellow-200',
  'yellow-300',

  /* PURPLE (SECONDARY) */
  'purple-0',
  'purple-25',
  'purple-50',
  'purple-100',
  'purple-200',
  'purple-300',

  /* BLUE (SECONDARY) */
  'blue-0',
  'blue-25',
  'blue-50',
  'blue-100',
  'blue-200',
  'blue-300',

  /* PINK (SECONDARY) */
  'pink-0',
  'pink-25',
  'pink-50',
  'pink-100',
  'pink-200',
  'pink-300',
]

export const backgroundColorUtilityClassList = [
  'background-level-0',
  'background-level-1',
  'background-level-2',
  'background-priority-1',
  'background-priority-2',
  'background-emphasis',
  'background-loud',
  'background-app',
]

export const borderColorUtilityClassList = [
  'disabled-border',
  'muted-border',
  'normal-border',
  'hover-border',
  'active-border',
]

export enum AccentColors {
  BRAND = 'brand',
  PRIORITY = 'priority',
  DANGER = 'danger',
}

export const dataColorUtilityClassList = [
  'data-lime',
  'data-green',
  'data-dark-green',
  'data-olive',
  'data-gold',
  'data-yellow',
  'data-blue',
  'data-purple',
]

export enum TextColors {
  DEFAULT = 'default',
  DISABLED = 'disabled',
  EMPHASIS = 'emphasis',
  HEADER = 'header',
  LINK = 'link',
  MUTED = 'muted',
  DANGER = 'danger',
  BRAND = 'brand',
  PRIORITY = 'priority',
  MOSS = 'moss',
  RED = 'red',
  ORANGE = 'orange',
  YELLOW = 'yellow',
  GREEN = 'green',
  WHITE = 'white',
}

export enum TypographyStyles {
  DISPLAY_LG = 'displayLg',
  DISPLAY_MD = 'displayMd',
  DISPLAY_SM = 'displaySm',
  DISPLAY_XS = 'displayXs',
  DISPLAY_XXS = 'displayXxs',
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  EYEBROW = 'eyebrow',
  LABEL_LG = 'labelLg',
  LABEL_MD = 'labelMd',
  LABEL_SM = 'labelSm',
  LABEL_XS = 'labelXs',
  BODY_LG = 'bodyLg',
  BODY_MD = 'bodyMd',
  BODY_SM = 'bodySm',
  BODY_XS = 'bodyXs',
}

export enum ImageBackgroundColors {
  ORANGE = 'bg-orange-25',
  YELLOW = 'bg-yellow-25',
  GREEN = 'bg-green-25',
  BLUE = 'bg-blue-25',
}

export const colorUtilityClassList = [
  ...backgroundColorUtilityClassList,
  ...Object.values(TextColors),
  ...borderColorUtilityClassList,
  ...Object.values(AccentColors),
  ...dataColorUtilityClassList,
  ...supportColorUtilityClassList,
]
